<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Kasir" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <!-- <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
                <div class="col-md-7 pr-1" v-if="detailLeftTop">
                    <DetailLeft :detailLeftTop="detailLeftTop"/>
                </div>
                <div class="col-md-5 pl-1" v-if="detailRightTop">
                    <DetailRight :detailRightTop="detailRightTop"/>
                </div>
            </div> -->
          <b-row class="mt-2">
            <b-col md="8">
              <a
                class="btn btn-info btn-with-icon-right btn-block"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="accordion-1"
                @click="visible = !visible"
                >{{ visible ? "Sembunyikan" : "Lihat" }} Rincian Pembayaran
                <i class="material-symbols-outlined">{{
                  visible ? "expand_less" : "expand_more"
                }}</i>
              </a>
            </b-col>
            <b-col md="4">
              <b-button
                block
                variant="primary btn-with-icon-left"
                :href="
                  `/#/kasir/invoice/operasi/${$route.params.id}/${$route.params.id_operasi_biaya}/rincian`
                "
                target="_blank"
              >
                <i class="material-symbols-outlined">print</i>
                Cetak Invoice
              </b-button>
            </b-col>
          </b-row>

          <b-collapse
            id="accordion-1"
            v-model="visible"
            accordion="my-accordion"
            role="tabpanel"
          >
            <div class="row">
              <div class="col-md-12" style="position: relative">
                <div class="d-flex flex-between my-3" v-if="operasi">
                  <h5 class="mb-2">Rincian Biaya Operasi</h5>
                </div>
                <table class="responsive" v-if="operasi">
                  <thead>
                    <th>KOMPONEN BIAYA</th>
                    <th>SUB TOTAL</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Biaya Paket Operasi</td>
                      <td>
                        {{ convertToRupiah(operasi.jenis_paket_operasi) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Jasa Dokter Operator</td>
                      <td>
                        {{ convertToRupiah(operasi.jasa_dokter_operator) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Jasa Dokter Anestesi</td>
                      <td>
                        {{ convertToRupiah(operasi.jasa_dokter_anestesi) }}
                      </td>
                    </tr>
                    <!-- <tr>
                      <td>Jasa Dokter Referal</td>
                      <td>
                        {{ convertToRupiah(operasi.jasa_dokter_referal) }}
                      </td>
                    </tr> -->
                    <tr>
                      <td>Jasa Perawat Anestesi</td>
                      <td>
                        {{ convertToRupiah(operasi.jasa_perawat_anestesi) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Jasa Instrumentator</td>
                      <td>
                        {{ convertToRupiah(operasi.jasa_instrumentator) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Jasa Perawat Sirkuler</td>
                      <td>
                        {{ convertToRupiah(operasi.jasa_perawat_sirkuler) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Sewa Kamar Operasi</td>
                      <td>{{ convertToRupiah(operasi.sewa_kamar_operasi) }}</td>
                    </tr>
                    <tr>
                      <td>Pemberian Obat Dan Alat Kesehatan</td>
                      <td>
                        {{
                          convertToRupiah(
                            operasi.pemberian_obat_dan_alat_kesehatan
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Biaya Lain-lain</td>
                      <td>{{ convertToRupiah(operasi.biaya_lain_lain) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>
                        <h4 class="my-2">Total Biaya Operasi</h4>
                      </td>
                      <td colspan="1" class="text-right">
                        <h4 class="my-2">
                          {{ convertToRupiah(operasi.total_tagihan) }}
                        </h4>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </b-collapse>
          <div class="py-1"></div>
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal melakukan pembayaran',
              content:
                'Terjadi kesalahan saat melakukan pembayaran, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil melakukan pembayaran',
              content: 'Proses pembayaran berhasil dilakukan',
            }"
          />
          <b-tabs pills>
            <b-tab
              title="Bayar"
              :active="tab == 'rincian'"
              @click="tab = 'rincian'"
            >
              <div class="card px-4 py-3 my-2" v-if="ringkasan">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row mb-4">
                      <div class="col-md-6">
                        <span
                          :class="
                            `badge badge-${
                              ringkasan.status == 'BELUM DIBAYAR'
                                ? 'danger'
                                : ringkasan.status == 'BELUM LUNAS'
                                ? 'warning'
                                : 'primary'
                            }`
                          "
                          >{{ ringkasan.status }}</span
                        >
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Nomor Pembayaran</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="mb-0">
                          {{ ringkasan ? ringkasan.no_pembayaran : "" }}
                        </h4>
                      </div>
                    </div>
                    <hr />
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Total Pembayaran</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="mb-0">
                          {{
                            ringkasan
                              ? convertToRupiah(ringkasan.total_bayar)
                              : "Rp 0"
                          }}
                        </h4>
                      </div>
                    </div>
                    <div class="row mb-3" v-if="ringkasan.ditanggung">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Ditanggung</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="">
                          {{
                            ringkasan
                              ? convertToRupiah(ringkasan.ditanggung)
                              : "Rp 0"
                          }}
                        </h4>
                        <h5 class="text-secondary">
                          Ditanggung oleh {{ asuransi[id_asuransi] }}
                        </h5>
                        <!-- <div class="card p-2 my-3" style="background:#7f8f9">
                                <p class="mb-1">Ditanggung oleh {{asuransi[id_asuransi]}}</p>
                                <h5 class="mb-0">Ditanggung oleh {{asuransi[id_asuransi]}}</h5>
                            </div> -->
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Yang harus dibayar</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="mb-0 text-info">
                          {{
                            ringkasan
                              ? convertToRupiah(
                                  ringkasan.total_bayar - ringkasan.ditanggung
                                )
                              : "Rp 0"
                          }}
                        </h4>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Telah dibayar</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="text-primary">
                          {{
                            ringkasan
                              ? convertToRupiah(ringkasan.dibayar)
                              : "Rp 0"
                          }}
                        </h4>
                        <a
                          class="btn btn-sm btn-secondary btn-with-icon-right"
                          @click="tab = 'riwayat'"
                        >
                          Lihat Riwayat Pembayaran
                          <i class="material-symbols-outlined">chevron_right</i>
                        </a>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <h4 class="mb-0 text-muted">Sisa bayar</h4>
                      </div>
                      <div class="col-md-6">
                        <h4 class="mb-0 text-danger">
                          {{
                            ringkasan
                              ? convertToRupiah(ringkasan.sisa_tagihan)
                              : "Rp 0"
                          }}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6 no-print"
                    v-if="
                      ringkasan &&
                        !(
                          ringkasan.status == 'LUNAS' ||
                          ringkasan.sisa_tagihan == 0
                        )
                    "
                  >
                    <FormRow
                      v-for="row in bayarForm"
                      v-bind:key="row.colnum + String(Math.random(1023))"
                      :row="row"
                      @handleChange="(e) => handleChange(e)"
                    />
                  </div>
                </div>
                <div
                  class="row"
                  v-if="
                    ringkasan &&
                      !(
                        ringkasan.status == 'LUNAS' ||
                        ringkasan.sisa_tagihan == 0
                      )
                  "
                >
                  <div class="col-md-12">
                    <button
                      @click="handleForm"
                      class="
                        btn btn-primary btn-with-icon-left
                        float-right
                        ml-3
                        text-uppercase
                      "
                    >
                      <i class="material-symbols-outlined">check_circle</i>
                      {{ lunas ? "LUNASI PEMBAYARAN" : "BAYAR" }}
                    </button>
                    <!-- <router-link class="btn btn-outline-danger btn-no-outline float-right text-uppercase" to="/kasir">Batalkan</router-link> -->
                    <a
                      class="
                        btn btn-outline-danger btn-no-outline
                        float-right
                        text-uppercase
                      "
                      @click="() => reset()"
                      >Batalkan</a
                    >
                  </div>
                </div>
              </div>
              <Loading v-else />
            </b-tab>
            <b-tab
              title="Riwayat Pembayaran"
              :active="tab == 'riwayat'"
              @click="tab = 'riwayat'"
            >
              <b-row v-if="ringkasan && riwayat">
                <b-col md="12">
                  <table class="responsive my-4">
                    <thead>
                      <tr>
                        <td colspan="2"></td>
                        <td>
                          <h5 class="my-2">Yang harus dibayar</h5>
                        </td>
                        <td colspan="1" class="text-right">
                          <h5 class="my-2">
                            {{
                              ringkasan
                                ? convertToRupiah(
                                    ringkasan.total_bayar - ringkasan.ditanggung
                                  )
                                : "Rp 0"
                            }}
                          </h5>
                        </td>
                      </tr>
                    </thead>
                    <thead v-if="riwayat && riwayat.length">
                      <th>TANGGAL</th>
                      <th>JAM</th>
                      <th>CARA BAYAR</th>
                      <th>JUMLAH PEMBAYARAN</th>
                    </thead>
                    <tbody v-if="riwayat && riwayat.length">
                      <tr
                        v-for="item in riwayat"
                        v-bind:key="item.id + Math.random(1024)"
                      >
                        <td>{{ item.formatted_tanggal }}</td>
                        <td>{{ item.formatted_jam }}</td>
                        <td>
                          {{ item.cara_bayar
                          }}{{ item.no_kartu ? " - " + item.no_kartu : "" }}
                        </td>
                        <td>{{ item.formatted_jumlah }}</td>
                      </tr>
                    </tbody>
                    <tfoot v-if="riwayat && riwayat.length">
                      <tr>
                        <td colspan="2"></td>
                        <td>
                          <h4 class="my-2">SISA PEMBAYARAN</h4>
                        </td>
                        <td colspan="1" class="text-right">
                          <h4 class="mt-2 mb-2">
                            {{
                              ringkasan
                                ? convertToRupiah(ringkasan.sisa_tagihan)
                                : "Rp 0"
                            }}
                          </h4>
                          <a
                            class="btn btn-sm btn-secondary btn-with-icon-right"
                            @click="tab = 'rincian'"
                          >
                            {{
                              ringkasan.status == "LUNAS"
                                ? "LIHAT RINCIAN"
                                : "LUNASI PEMBAYARAN"
                            }}
                            <i class="material-symbols-outlined"
                              >chevron_right</i
                            >
                          </a>
                        </td>
                      </tr>
                    </tfoot>
                    <tfoot v-else>
                      <tr>
                        <td colspan="2"></td>
                        <td>
                          <p>Belum ada Riwayat Pembayaran di sini</p>
                        </td>
                        <td colspan="1" class="text-right">
                          <a
                            class="btn btn-sm btn-secondary btn-with-icon-right"
                            @click="tab = 'rincian'"
                          >
                            LAKUKAN PEMBAYARAN
                            <i class="material-symbols-outlined"
                              >chevron_right</i
                            >
                          </a>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </b-col>
              </b-row>
              <Loading v-else />
            </b-tab>
          </b-tabs>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
// import SearchResult from '@/components/SearchResult.vue'
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
// import DetailLeft from '@/components/DetailLeft.vue'
// import DetailRight from '@/components/DetailRight.vue'
import Loading from "@/components/Loading.vue";
import FormData from "form-data";
import { setBayarIntro, convertToRupiah, resetForms } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import { dataOperasi, jumlahForm, bayarForm } from "@/data/KasirForm.js";

export default {
  name: "KasirFormOperasi",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    DetailTop,
    Alert,
    FormRow,
    Loading,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      id_asuransi: null,
      id_ralan: "",
      lunas: false,
      visible: false,
      tab: "rincian",
      data: dataOperasi,
      convertToRupiah: convertToRupiah,
      history: [],
      asuransi: { 1: "Umum", 2: "BPJS", 3: "Asuransi" },
      jumlahForm: jumlahForm,
      bayarForm: bayarForm,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      saveSuccess: false,
      saveFailed: false,
      formSet: {
        id_tagihan_ringkasan: "",
        id_bank: "",
        jumlah: "",
        cara_bayar: "",
        no_kartu: "",
        lunas: [],
      },
      n: 0,
      operasi: {},
      doc: [],
      nrs: [],
      both: [],
      lab_count: 0,
      doc_count: 0,
      nrs_count: 0,
      both_count: 0,
      isError: false,
      ringkasan: null,
      riwayat: null,
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      let self = this;
      self.errors = [];
      let formData = new FormData();
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          if (key != "lunas") {
            formData.append(key, self.formSet[key]);
          }
        });
        try {
          let result = await this.$store.state.HTTP.post(
            "menu/kasir/tagihan_pembayaran",
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.saveSuccess = true;
          } else {
            this.saveFailed = true;
          }
          this.checkSuccess();
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        //console.log("tidak valid");
      }
    },
    fetchBanks: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "bank?per_page=9999999999"
        );
        ////console.log(result);
        if (result.status == "200") {
          ////console.log(result.data);
          let items = result.data.data;
          ////console.log(items);
          this.bayarForm[3].columns[0].options = items.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    checkSuccess() {
      var that = this;
      if (!this.saveFailed) {
        this.saveSuccess = true;
        that.reinit();
      } else {
        this.saveSuccess = false;
      }
      setTimeout(function() {
        that.saveSuccess = false;
        that.saveFailed = false;
      }, 3000);
    },
    reset(url, stay) {
      // if (this.validated) {
      resetForms(
        this.formSet,
        [this.jumlahForm, this.bayarForm],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (!stay) {
          if (this.fromUrl && fromTab) {
            let queryString = "?tab=" + fromTab;

            ////console.log(backBtn)
            this.$router.push({ path: backBtn + queryString });
          } else {
            ////console.log(window.history);
            if (backBtn) {
              this.$router.push({ path: backBtn });
            } else {
              this.$router.go(-1);
            }
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
      if (e.target.name == "cara_bayar") {
        if (e.target.value == "Tunai") {
          this.bayarForm[3].columns[0].value = "";
          this.bayarForm[3].columns[0].type = "hidden";
          this.bayarForm[3].columns[0].optional = true;
          this.bayarForm[4].columns[0].type = "hidden";
          this.bayarForm[4].columns[0].optional = true;
          this.formSet["no_kartu"] = "";
          this.formSet["id_bank"] = "";
        } else {
          this.bayarForm[3].columns[0].type = "select";
          this.bayarForm[3].columns[0].optional = false;
          this.bayarForm[4].columns[0].type = "text";
          this.bayarForm[4].columns[0].optional = false;
        }
        this.bayarForm[0].columns[0].value = this.formSet["jumlah"];
        this.bayarForm[1].columns[0].value = this.formSet["lunas"];
        this.bayarForm[2].columns[0].value = this.formSet["cara_bayar"];
      }
      if (
        e.target.name == "jumlah" &&
        parseInt(e.target.value) < parseInt(this.ringkasan.sisa_tagihan) &&
        this.lunas
      ) {
        this.formSet["lunas"] = [];
        this.bayarForm[1].columns[0].value = this.formSet["lunas"];
        this.bayarForm[0].columns[0].value = this.formSet["jumlah"];
        this.bayarForm[2].columns[0].value = this.formSet["cara_bayar"];
        this.lunas = false;
      }
      if (e.target.name == "lunas") {
        //console.log(e.target.value);
        // this.lunas=false;
        if (e.target.value && e.target.value.length) {
          this.lunas = true;
          this.bayarForm[0].columns[0].value = this.ringkasan.sisa_tagihan;
          this.formSet["jumlah"] = this.ringkasan.sisa_tagihan;
          // this.bayarForm[0].columns[0].value=revertToNumber(this.ringkasan.sisa_tagihan);
        } else {
          this.formSet[e.target.name] = [];
          this.bayarForm[1].columns[0].value = this.formSet["lunas"];
          this.lunas = false;
          this.bayarForm[0].columns[0].value = 0;
          this.formSet["jumlah"] = 0;
        }
      }
    },
    updateForm() {
      this.bayarForm[0].columns[0].value = this.formSet["jumlah"];
      this.bayarForm[1].columns[0].value = this.formSet["lunas"];
      this.bayarForm[2].columns[0].value = this.formSet["cara_bayar"];
      this.bayarForm[3].columns[0].value = this.formSet["no_kartu"];
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      this.bayarForm = this.bayarForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            if (
              column.name == "jumlah" &&
              parseInt(self.formSet[column.name]) >
                parseInt(self.ringkasan.sisa_tagihan)
            ) {
              valid = false;
              column.error =
                "Jumlah pembayaran lebih besar dari pada sisa tagihan";
            } else {
              column.error = "";
            }
          }
          if (self.formSet[column.name]) {
            column.value = self.formSet[column.name];
          }
          return column;
        });
        return row;
      });
      return valid;
    },
    fetchRingkasan: async function(reinit) {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_ringkasan/${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == 200) {
          this.id_ralan = result.data.id_ralan;
          this.ringkasan = result.data;
          let resultRalan = await this.$store.state.HTTP.get(
            `ralan/${this.id_ralan}`
          );
          this.id_asuransi = resultRalan?.data?.id_asuransi;
          //console.log(resultRalan);
          this.detailTop = setBayarIntro(resultRalan.data);
          this.id_biaya = this.$route.params.id_operasi_biaya;
          let resultOperasi = await this.$store.state.HTTP.get(
            `operasi_biaya/${this.id_biaya}`
          );
          if (resultOperasi.status == 200) {
            //console.log(resultOperasi);
            this.operasi = resultOperasi.data;
            // this.operasi_count=0;
            // this.operasi.forEach((item)=>{
            //   //console.log(item);
            //   this.operasi_count+=item.biaya;
            // })
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
          if (reinit && result.data.status == "LUNAS") {
            //console.log('Kirim data ke SIAKUN saat reinitialization jika status==LUNAS');
            //console.log(this.$store.state.HTTP_SIAKUN);
            await this.$store.state.HTTP_SIAKUN.post(
              "faktur-penjualan/tambah-simrs",
              {
                kode_pelanggan: resultRalan.data.no_rm,
                tanggal: new Date().toISOString().split("T")[0],
                deskripsi: `Operasi ${resultRalan.data.no_rawat} - ${resultRalan.data.jen_periksa} ${resultRalan.data.pasien.nama}`,
                isLunas: 1,
                isPengirimanBarang: 0,
                items: [
                  {
                    kodeProduk: "Operasi",
                    deskripsi: `Total Biaya Operasi`,
                    jumlahProduk: 1,
                    pajak_id: 0,
                    diskon: 0,
                    hargaSatuan: result.data.dibayar,
                    subtotal: result.data.dibayar,
                  },
                ],
              }
            );
            //console.log(resultSiakun);
          }
          // Kirim data ke SIAKUN saat reinitialization jika status==LUNAS
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    fetchRiwayat: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `menu/kasir/tagihan_pembayaran?id_tagihan_ringkasan=${this.$route.params.id}`
        );
        //console.log(result);
        if (result.status == "200") {
          //console.log(result);
          this.riwayat = result.data.data;
          //console.log(this.riwayat);
        } else {
          //   this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    init: async function() {
      this.tab = this.$route.params.tab;
      this.formSet.id_tagihan_ringkasan = this.$route.params.id;
      this.fetchRingkasan();
      this.fetchRiwayat();
    },
    print: async function() {
      if (this.ringkasan && this.riwayat) window.print();
    },
    reinit: async function() {
      this.tab = this.$route.params.tab;
      this.formSet.id_tagihan_ringkasan = this.$route.params.id;
      this.fetchRingkasan(true);
      this.fetchRiwayat();
      this.reset("", true);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.init();
    this.fetchBanks();
    this.data.toReset = (url) => this.reset(url);
  },
};
</script>
